module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "a-table a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('th', [_vm._v("Employment Income")]), _vm._v(" "), _c('th', [_vm._v("Net/Gross")]), _vm._v(" "), _c('th', [_vm._v("Total Net Income")]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "p-pi-income__ashe-average"
  }, [_c('p', [_vm._v("ASHE Average")]), _vm._v(" "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "ashe"
    }
  }, [_c('div', {
    staticClass: "p-pi-income__ashe-average-tooltip"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-text": "Click to view information",
      "side": "bottom",
      "text-width": "140",
      "icon-type": "info",
      "icon-colour": "m-icon--light"
    }
  })], 1)])], 1)])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                            Pre-Accident Earnings\n                        ")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.preEmploymentIncome),
      expression: "preEmploymentIncome"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "required": "",
      "disabled": _vm.getIncomeValue('pastLossOfEarnings')
    },
    domProps: {
      "value": (_vm.preEmploymentIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preEmploymentIncome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('control', {
    attrs: {
      "tip-text": "ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "future_losses_constant",
      "tipShow": !_vm.getIncomeValue('pastLossOfEarnings') && _vm.preAccidentDisableNetGross,
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preEmploymentNetGross),
      expression: "preEmploymentNetGross"
    }],
    attrs: {
      "disabled": _vm.getIncomeValue('pastLossOfEarnings') || _vm.preAccidentDisableNetGross
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.preEmploymentNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.preTotalNetIncome),
      expression: "preTotalNetIncome"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.preTotalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preTotalNetIncome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "a-button u-no-margin ashe p-pi-income__ashe-average-button",
    attrs: {
      "disabled": _vm.getIncomeValue('pastLossOfEarnings')
    },
    on: {
      "click": function($event) {
        return _vm.selectSalary(null, 'pre')
      }
    }
  }, [_vm._v("\n                                Use ASHE average\n                            ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin refine",
    attrs: {
      "disabled": _vm.getIncomeValue('pastLossOfEarnings')
    },
    on: {
      "click": function($event) {
        return _vm.openDialog('pre')
      }
    }
  }, [_vm._v("\n                                Refine by occupation\n                            ")])])]), _vm._v(" "), (_vm.getIncomeValue('pastLossOfEarnings') || _vm.futureLossesConstant) ? _c('tr', [_c('td', [_vm._v("\n                            Post-Accident Earnings\n                        ")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.postEmploymentIncome),
      expression: "postEmploymentIncome",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "required": ""
    },
    domProps: {
      "value": (_vm.postEmploymentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.postEmploymentIncome = _vm.postEmploymentIncome || ''
      },
      "blur": [function($event) {
        _vm.postEmploymentIncome = _vm.postEmploymentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postEmploymentIncome = _vm._n($event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('control', {
    attrs: {
      "tip-text": "ASHE Data are gross median figures. Therefore the Net function has been disabled. To re-enable edit the employment income figure.",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-width": "250",
      "tip-name": "future_losses_constant",
      "tipShow": _vm.postAccidentDisableNetGross,
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postEmploymentNetGross),
      expression: "postEmploymentNetGross"
    }],
    attrs: {
      "disabled": _vm.postAccidentDisableNetGross
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.postEmploymentNetGross = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])])], 1), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.postTotalNetIncome),
      expression: "postTotalNetIncome"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.postTotalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postTotalNetIncome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "a-button u-no-margin ashe p-pi-income__ashe-average-button",
    on: {
      "click": function($event) {
        return _vm.selectSalary(null, 'post')
      }
    }
  }, [_vm._v("\n                                Use ASHE average\n                            ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin refine",
    on: {
      "click": function($event) {
        return _vm.openDialog('post')
      }
    }
  }, [_vm._v("\n                                Refine by occupation\n                            ")])])]) : _vm._e()])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'ons_salary_' + this.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('div', {
    staticClass: "p-day-one__refine-occupation"
  }, [_c('h2', [_vm._v("Refine by occupation")]), _vm._v(" "), (_vm.selectedNode) ? _c('div', [_c('p', [_vm._v("\n                    Your current selection - "), _c('strong', [_vm._v(_vm._s(_vm.getLastNode().description))]), _c('br'), _vm._v(" "), (_vm.getLastNode().code.length !== 3) ? _c('span', [_vm._v("Select a salary, expand down further or use the average salary for this whole group")]) : _c('span', [_vm._v("Select a salary or use the average salary for this whole group")])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.unselectNode(_vm.selectedNode)
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.selectSalary(_vm.selectedNode)
      }
    }
  }, [_vm._v("Use average " + _vm._s(_vm.displaySalary(_vm.selectedNode)))])]) : _c('div', [_c('p', [_vm._v("\n                    Select a salary or expand the group\n                ")])]), _vm._v(" "), _c('div', [_c('div', [_c('table', {
    staticClass: "a-table__small a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('tbody', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "a-loader--table"
  })])]) : _c('tbody', _vm._l((_vm.nodes), function(node) {
    return _c('tr', {
      staticClass: "selected--row"
    }, [_c('td', [_vm._v(_vm._s(node.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displaySalary(node)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "a-button a-button--small",
      attrs: {
        "disabled": node.code.length === 4
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectNode(node)
        }
      }
    }, [_vm._v("\n                                    Expand\n                                ")])]), _vm._v(" "), _c('td', [(node.salary !== 'x') ? _c('button', {
      staticClass: "a-button a-button--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectSalary(node, _vm.type)
        }
      }
    }, [_vm._v("\n                                    Select\n                                ")]) : _vm._e()])])
  }), 0)])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ashe",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("ASHE Average")]), _vm._v("\n        We have provided average gross (median) earnings by selected gender & occupational categories according to the Average Survey of Hours and Earnings (ASHE). The data are collected and published by the Office of National Statics (ONS) annually and can be found here.\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60c6fed9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/income/PostAccidentIncome.vue
// module id = 1717
// module chunks = 0